import http from 'plugins/axios';

export default {
  getRecords(data) {
    return http.get({
      url: '/la/admin/pledge/inRecord',
      data
    });
  },
  gitSwitch(data) {
    return http.get({
      url: '/la/admin/pledge/bigSwitch',
      data
    });
  },
  setSwitch(data) {
    return http.post({
      url: '/la/admin/pledge/bigSwitch',
      data,
      dataType: 'form'
    });
  }
};
